import { render } from "./ProfessionView.vue?vue&type=template&id=85278698&scoped=true"
import script from "./ProfessionView.vue?vue&type=script&lang=js"
export * from "./ProfessionView.vue?vue&type=script&lang=js"

import "./ProfessionView.vue?vue&type=style&index=0&id=85278698&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85278698"]])

export default __exports__